document.addEventListener('DOMContentLoaded', async () => {
  const sectionsToRender =
    [
      {
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }
    ]
  const productPromises =
    Array.from(document.querySelectorAll('[data-srt-sku]'))
      .map((element) => element.innerHTML)
      // Get Unique Only
      .filter((val, idx, ary) => ary.indexOf(val) === idx)
      .map((handle) => {
        return fetch(`${window.Shopify.routes.root}products/${handle}.js`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        })
          .then(response => response.json())
          .catch(err => { console.error(err) })
      })
  const products = await Promise.all(productPromises)

  const findVariant = (sku) => {
    for (let i in products) {
      for (let j in products[i].variants) {
        if (products[i].variants[j].sku === sku) {
          return [products[i].variants[j], products[i]]
        }
      }
    }
  }

  const displayPrice = (price) =>
    (price / 100)
      .toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })

  // Most of this is copied from the theme code to manage cart stuff
  const launchCart = (cartData) => {
    sectionsToRender.forEach(section => {
      if (!document.getElementById(section.id)) {
        return
      }

      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)
      elementToReplace.innerHTML =
        new DOMParser()
          .parseFromString(cartData.sections[section.section], 'text/html')
          .querySelector(section.selector).innerHTML
      if (typeof CartDrawer !== 'undefined') {
        new CartDrawer()
      }
      if (typeof Cart !== 'undefined') {
        new Cart().renderContents(cartData)
      }

      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active')
        document.body.classList.add('open-cart')
        document.body.classList.add('open-cc')
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active')
        }
        dispatchCustomEvent('cart-drawer:open')
      }
    })
  }

  document.querySelectorAll('[data-srt-variant-sku]').forEach((element) => {
    const sku = element.innerHTML
    const [variant, product] = findVariant(sku)
    const parent = element.parentElement

    // Price replacement
    Array.from(parent.querySelectorAll('[data-srt-product-price]')).forEach(element => {
      element.innerHTML = displayPrice(variant.price)
    })

    // Compare Price replacement
    Array.from(parent.querySelectorAll('[data-srt-product-compare-price]')).forEach(element => {
      element.innerHTML = displayPrice(variant.compare_at_price)
    })

    // Image src replacement
    Array.from(parent.querySelectorAll('[data-srt-product-image]')).forEach(element => {
      element.src = variant.featured_image || product.images[0]
    })

    // Product Title
    Array.from(parent.querySelectorAll('[data-srt-product-title]')).forEach(element => {
      element.innerHTML = product.title
    })

    // Add to Cart button
    if (parent.dataset.srtAddToCart === 'true') {
      Array.from(parent.querySelectorAll('.text-atc')).forEach(element => {
        if (!variant.available) {
          element.innerHTML = 'Sold Out'
        }
      })

      parent.addEventListener('click', (event) => {
        event.preventDefault()
        const config = {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
          }
        }

        let formData = new FormData(this.form)

        formData.append('id', variant.id)
        formData.append('quantity', 1)
        formData.append('sections', sectionsToRender.map((section) => section.section))
        formData.append('sections_url', window.location.pathname)

        config.body = formData
        fetch(window.Shopify.routes.root + 'cart/add.js', config)
          .then(response => response.json())
          .then(json => launchCart(json))
      })
    }
  })

})
